import React, { Component } from 'react';
import ApiBitcoin from '../../utils/api.bitcoin';

class ShowValue extends Component {
  ticker;
  _ismounted;

  constructor(props) {
    super(props);
    this.state = {
      btc: parseFloat(this.props.btc).toLocaleString('pt'),
      dollar: 'Loading',
      ticker: undefined
    };

    if(sessionStorage.getItem('ticker')) {
      this.state.ticker = JSON.parse(sessionStorage.getItem('ticker'));
    }

    if(!this.state.ticker) {
      new ApiBitcoin().get()
      .then(response => {
        if(response.data) {
          sessionStorage.setItem('ticker', JSON.stringify(response.data));
          this.state.ticker = response.data;
          this._loadDollarValue();
        }
      });
    } else {
      this._loadDollarValue(props.btc);
    }

  }

  componentDidMount() { 
    this._ismounted = true;
  }
  
  componentWillUnmount() {
     this._ismounted = false;
  }

  _loadDollarValue(btc) {
    if(this.state.ticker) {
      let finalValue = parseFloat((this.state.ticker.USD['15m'] / 100000000 ) * btc).toFixed(2);

      if(!this._ismounted) {
        this.state.dollar = 'US$ ' + finalValue;
      } else {
        this.setState(...this.state, {
          dollar: 'US$ ' + finalValue
        });
      }
    }
  } 

  render() {
    return (
      <span className={ this.props.className }>
        { this.state.btc } Sats 
        <br hidden={ this.props.withoutBreak } /> 
        <span hidden={ !this.props.withoutBreak }> / </span> 
        { this.state.dollar }
      </span>
    );
  }

  componentWillReceiveProps(props) {
    this.setState(...this.state, {
      btc: parseFloat(props.btc).toLocaleString('en'),
      dollar: ''
    });

    this._loadDollarValue(props.btc);
  }
}

export default ShowValue;


// WEBPACK FOOTER //
// ./src/components/ShowValue/index.js